<template>
  <img v-if="username === 'ep6346!'" style="width:100%;" src="@/assets/images/_temp_dashboard.svg" />

  <div v-else-if="username === 'gagc4680!'">
    <img style="width:100%;" src="@/assets/images/dashboard/gagc4680_1.svg" />
    <img style="width:100%;" src="@/assets/images/dashboard/gagc4680_2.svg" />
  </div>

  <div v-else-if="username === 'gsgc2901!'">
    <img style="width:100%;" src="@/assets/images/dashboard/gsgc2901_1.svg" />
    <img style="width:100%;" src="@/assets/images/dashboard/gsgc2901_2.svg" />
  </div>
  <div v-else-if="username === 'gsgc2902!'">
    <img style="width:100%;" src="@/assets/images/dashboard/gsgc2902_1.svg" />
    <img style="width:100%;" src="@/assets/images/dashboard/gsgc2902_2.svg" />
  </div>

  <div v-else-if="username === 'gsgc2903!'">
    <img style="width:100%;" src="@/assets/images/dashboard/gsgc2903_1.svg" />
    <img style="width:100%;" src="@/assets/images/dashboard/gsgc2903_2.svg" />
  </div>
  <div v-else-if="username === 'gsndc2760!'">
    <img style="width:100%;" src="@/assets/images/dashboard/gsndc2760_1.svg" />
    <img style="width:100%;" src="@/assets/images/dashboard/gsndc2760_2.svg" />
  </div>
  <div v-else-if="username === 'gsndc2762!'">
    <img style="width:100%;" src="@/assets/images/dashboard/gsndc2762_1.svg" />
    <img style="width:100%;" src="@/assets/images/dashboard/gsndc2762_2.svg" />
  </div>

  <div v-else-if="username === 'gsndc2765!'">
    <img style="width:100%;" src="@/assets/images/dashboard/gsndc2765_1.svg" />
    <img style="width:100%;" src="@/assets/images/dashboard/gsndc2765_2.svg" />
  </div>

  <div v-else-if="username === 'gsndc2782!'">
    <img style="width:100%;" src="@/assets/images/dashboard/gsndc2782_1.svg" />
    <img style="width:100%;" src="@/assets/images/dashboard/gsndc2782_2.svg" />
  </div>
  <div v-else-if="username === 'gsnd2760!'">
    <img style="width:100%;" src="@/assets/images/dashboard/gsnd2760_1.svg" />
    <img style="width:100%;" src="@/assets/images/dashboard/gsnd2760_2.svg" />
  </div>

<!--  대구중구-->
  <div v-else-if="username === 'dgjg2250!'">
    <img style="width:100%;" src="@/assets/images/dashboard/dgjg2250_1.svg" />
    <img style="width:100%;" src="@/assets/images/dashboard/dgjg2250_2.svg" />
  </div>
  <div v-else-if="username === 'dgjg2332!'">
    <img style="width:100%;" src="@/assets/images/dashboard/dgjg2332_1.svg" />
    <img style="width:100%;" src="@/assets/images/dashboard/dgjg2332_2.svg" />
  </div>
  <div v-else-if="username === 'dgjg2333!'">
    <img style="width:100%;" src="@/assets/images/dashboard/dgjg2333_1.svg" />
    <img style="width:100%;" src="@/assets/images/dashboard/dgjg2333_2.svg" />
  </div>
  <div v-else-if="username === 'dgjg2335!'">
    <img style="width:100%;" src="@/assets/images/dashboard/dgjg2335_1.svg" />
    <img style="width:100%;" src="@/assets/images/dashboard/dgjg2335_2.svg" />
  </div>

<!--  광주남구-->
  <div v-else-if="username === 'gjng2900!'">
    <img style="width:100%;" src="@/assets/images/dashboard/gjng2900_1.svg" />
    <img style="width:100%;" src="@/assets/images/dashboard/gjng2900_2.svg" />
  </div>
  <div v-else-if="username === 'gjng2920!'">
    <img style="width:100%;" src="@/assets/images/dashboard/gjng2920_1.svg" />
    <img style="width:100%;" src="@/assets/images/dashboard/gjng2920_2.svg" />
  </div>

  <vs-row v-else>
    <vs-col>
<!--      <div class="flex mb-4" style="justify-content: end;">-->
<!--        <vs-button color="secondary" @click="()=>{-->
<!--          this.$router.push({name:'smart-report'})-->
<!--        }">스마트보고서</vs-button>-->
<!--      </div>-->
      <div class="dashboard-layout-2">
        <home-notification-card title="은평구청 안전·보건 경영 시스템 " :disabled="myInfo.is_superuser >= 1 ? false : true"/>
        <community-healthinfo-card />
        <community-business-news-card />
        <community-work-news-card />
      </div>
      <div v-if="hasDashboardCharts" class="dashboard-layout-auto">
        <component v-for="chart in hasDashboardCharts" :is="chart" dataType="project"/>
      </div>
      <div v-if="successLoadGraph && !hasDashboardCharts" class="dashboard-layout-auto">
        <donut-chart01 dataType="project"/>
        <donut-chart02 dataType="project"/>
        <donut-chart03 dataType="project"/>
<!--        <donut-chart04 dataType="project"/>-->
        <donut-chart05 dataType="project"/>
        <health-safety-budget-execution-rate-chart data-type="project"/>
        <donut-chart06 dataType="project"/>
        <donut-chart07 dataType="project"/>
        <donut-chart08 dataType="project"/>
        <donut-chart09 dataType="project"/>
        <donut-chart10 dataType="project"/>
        <donut-chart11 dataType="project"/>
        <donut-chart12 dataType="project"/>
        <donut-chart13 dataType="project"/>
        <donut-chart14 dataType="project"/>
      </div>
    </vs-col>
  </vs-row>
</template>

<script>
import DonutChartCard from '@/components/DonutChartCard'
import HomeNotificationCard from '@/components/HomeNotificationCard'
import CommunityHealthinfoCard from '@/components/CommunityHealthinfoCard'
import CommunityWorkNewsCard from '@/components/CommunityWorkNewsCard'
import CommunityBusinessNewsCard from '@/components/CommunityBusinessNewsCard'
import DonutChart01 from '@/views/graph/DonutChart01'
import DonutChart02 from '@/views/graph/DonutChart02'
import DonutChart03 from '@/views/graph/DonutChart03'
import DonutChart04 from '@/views/graph/DonutChart04'
import DonutChart05 from '@/views/graph/DonutChart05'
import DonutChart06 from '@/views/graph/DonutChart06'
import DonutChart07 from '@/views/graph/DonutChart07'
import DonutChart08 from '@/views/graph/DonutChart08'
import DonutChart09 from '@/views/graph/DonutChart09'
import DonutChart10 from '@/views/graph/DonutChart10'
import DonutChart11 from '@/views/graph/DonutChart11'
import DonutChart12 from '@/views/graph/DonutChart12'
import DonutChart13 from '@/views/graph/DonutChart13'
import DonutChart14 from '@/views/graph/DonutChart14'
import HealthSafetyBudgetExecutionRateChart from '@/views/graph/HeathSafetyBudgetExecutionRateChart'

export default {
  components: {
    HealthSafetyBudgetExecutionRateChart,
    DonutChart14,
    DonutChart13,
    DonutChart12,
    DonutChart11,
    DonutChart10,
    DonutChart09,
    DonutChart08,
    DonutChart07,
    DonutChart06,
    DonutChart05,
    DonutChart04,
    DonutChart03,
    DonutChart02,
    DonutChart01,
    CommunityBusinessNewsCard,
    CommunityWorkNewsCard,
    CommunityHealthinfoCard,
    HomeNotificationCard,
    DonutChartCard
  },
  data () {
    return {
      successLoadGraph: false
    }
  },
  computed:{
    myInfo () {
      return this.$store.state.auth.userInfo
    },
    username () {
      return this.myInfo ? this.myInfo.username : ''
    },
    hasDashboardCharts () {
      const memberInfo = this.$store.state.member.memberInfo;
      const hasDashboardCharts = memberInfo.has_dashboard_charts
      if (hasDashboardCharts) {
        const list = []
        for (const chart of hasDashboardCharts) {
          if (chart.visible && chart.project_id === 0) {
            list.push(chart.dashboard_chart.code)
          }
        }
        return list
      }

      return undefined
    }
  },
  async created () {
    await this.$store.dispatch("member/LOAD_MEMBER_DETAIL").then(value => {
      this.successLoadGraph = true
    });
  },
  async mounted () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.dashboard-layout-2 {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  margin-bottom: 16px;
  @media (min-width: 960px) {
    grid-template-columns: 1fr 1fr;
  }
}
.dashboard-layout-auto {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;

  @media (min-width: 960px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (min-width: 1310px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
  @media (min-width: 1660px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
}
</style>
